import I18n from 'I18n';
import { hubToProductLine } from '../../constants/ProductLineToHub';

/*
  Features have their own descriptions which is the default. However,
  some features have a unique description depending on which hub it
  is attached to. Rather than have to attach feature
  descriptions to every single hub though, we model the data to
  represent this as it is in real life... by default each feature
  has its own description, and it can be overridden by having a
  more specific description tied to the hub. This utility helper
  helps black box that logic to implementations.
 */
export const getProductFeatureDescriptionKey = (featureKey, productLine) => {
  if ( // @ts-expect-error not migrated to TS
  I18n.lookup(`pricing-pages.features.${featureKey}.description.${productLine}`)) {
    return `pricing-pages.features.${featureKey}.description.${productLine}`;
  }

  return `pricing-pages.features.${featureKey}.description.default`;
};

const getFeatureDescriptionKey = (featureKey, hubKey) => {
  return getProductFeatureDescriptionKey(featureKey, hubToProductLine[hubKey]);
};

export default getFeatureDescriptionKey;